<template>
  <v-dialog v-model="dialog_receipt" persistent content-class="component_dialog7 inrec__wrapper">
    <v-row class="inrec__wrap">
      <v-col cols="12" class="d-flex align-center justify-space-between header__wrap">
        <div class="h__title">
          <h2>Receipt</h2>
          <p>إيصال</p>
        </div>
        <div class="h__logo">
          <v-img width="110px" src="@/assets/img/header_logo2.png"></v-img>
          <v-btn class="modal__close__btn" dense @click="$emit('close')"></v-btn>
        </div>
      </v-col>
      <v-col cols="12" class="h__captions__wrap">
        <div class="captions_1">
          <p>{{ $t('common.common.top_desc4') }}</p>
          <p>{{ $t('common.common.top_desc1') }}</p>
        </div>
        <div class="captions_2">
          <p>{{ $t('common.common.office_address') }}</p>
          <p>(202) 279-21291 - (202) 279-21274</p>
          <p>patinfo@egypo.gov.eg</p>
        </div>
      </v-col>
      <v-col cols="12" class="data__title">
        <div>
          <p class="ft-size14">{{ $t('component.dialog_invoice.fields.bill_to') }}</p>
          <p>{{ $vuetify.rtl ? receipt.company_name_ar : receipt.company_name_en }}</p>
          <p>{{ $vuetify.rtl ? receipt.address_ar : receipt.address_en }}</p>
        </div>
        <div>
          <p>{{ $t('component.dialog_invoice.fields.paid_date') }} : {{receipt.paid_date}}</p>
          <p>{{ $t('component.dialog_invoice.fields.receipt_no') }} : {{receipt.receipt_no}}</p>
          <p>{{ $t('component.dialog_invoice.fields.confirmation_no') }} : {{receipt.receipt_confirm_no}}</p>
        </div>
      </v-col>

      <v-col cols="12" class="inrec__list">
        <v-data-table
          :headers="$getHeaderType2(headerTxt, headerEn, headerAr)"
          :items="receiptList"
          hide-default-footer
          :items-per-page="100"
          class="inrec__type"
          :mobile-breakpoint="MobileBreakPoint"
          disable-sort
        >
          <template v-slot:header.application_no="{ header }">
            <div>{{ $t('component.dialog_invoice.fields.application_no') }}</div>
            <div>({{ $t('component.dialog_invoice.fields.receiving_no') }})</div>
          </template>
          <template v-slot:item.application_no="{ item }">
            <div>{{ item.application_no }}</div>
            <div v-if="item.receiving_no">({{ item.receiving_no }})</div>
          </template>
          <template v-slot:item.amount="{ item }">
            <div>{{ item.amount | comma }}</div>
          </template>
          <template v-slot:item.late_charge_amount="{ item }">
            <div>{{ item.late_charge_amount | comma }}</div>
          </template>
          <template v-slot:item.total_amount="{ item }">
            <div>{{ item.amount + item.late_charge_amount | comma }}</div>
          </template>
        </v-data-table>
      </v-col>

      <v-col cols="12" class="dojang__wrap">
        <img src="@/assets/img/dojang.jpg" />
      </v-col>

      <v-col cols="12" class="d-flex btn__c__wrap">
        <v-btn
          outlined
          rounded
          height="45"
          width="150"
          color="#333"
          @click="fnDownloadReceiptPdf('ar')"
        >{{ $t('common.button.download') }} ({{ $t('common.common.ar') }})</v-btn>
        <v-spacer class="hidden_lr10"></v-spacer>
        <v-btn
          outlined
          rounded
          height="45"
          width="150"
          color="#333"
          @click="fnDownloadReceiptPdf('en')"
        >{{ $t('common.button.download') }} ({{ $t('common.common.en') }})</v-btn>
        <v-spacer></v-spacer>
      </v-col>
    </v-row>


  </v-dialog>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'

export default {
  name : "DialogReceipt",
  props : {
    prop_dialog_receipt : {
      type : Boolean,
      default : false
    },
    prop_receipt : {
      type : Object
    }
  },
  components :{
  },
  data () {
    return {
      MobileBreakPoint : 0,

      headerTxt : {
        prefix : 'component.dialog_invoice.fields.',
        txt : [ '#', 'application_no', 'descriptions', 'qty','rate','late_charge','amount' ]
      },
      headerAr: [
        { text: '#', align: 'center', value: 'no', width: 50 },
        { text: 'Application No', align: 'center', value: 'application_no', width: 130 },
        { text: 'Description', align: 'start', value: 'name_ar', width: '40%' },
        { text: 'Qty', align: 'center', value: 'qty' },
        { text: 'Rate', align: 'center', value: 'amount' },
        { text: 'Late Charge',  align: 'center', value: 'late_charge_amount' },
        { text: 'Amount',  align: 'center', value: 'total_amount' }
      ],
      headerEn: [
        { text: '#', align: 'center', value: 'no', width: 50 },
        { text: 'Application No', align: 'center', value: 'application_no', width: 130 },
        { text: 'Description', align: 'start', value: 'name_en', width: '40%' },
        { text: 'Qty', align: 'center', value: 'qty' },
        { text: 'Rate', align: 'center', value: 'amount' },
        { text: 'Late Charge',  align: 'center', value: 'late_charge_amount' },
        { text: 'Amount',  align: 'center', value: 'total_amount' }
      ],
      dialog_receipt: false,
      receipt: {}
    }
  },
  watch : {
    prop_dialog_receipt() {
      this.dialog_receipt = _.cloneDeep(this.prop_dialog_receipt)
    },
    prop_receipt() {
      this.receipt = _.cloneDeep(this.prop_receipt)
      this.receipt.no = 1
      this.receipt.qty = 1
    }
  },
  filters:{
    comma(val){
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  },
  computed: {
    receiptList() {
      let list = []

      list.push(this.receipt)

      return list
    }
  },
  methods : {
    fnDownloadReceiptPdf(lang) {
      let receipt_file_key = this.receipt.receipt_file_key_ar
      if (lang === 'en') {
        receipt_file_key = this.receipt.receipt_file_key_en
      }
      if(utils.isNull(receipt_file_key)){
        let snackBarOptions = {
          text: this.$t('maintenance.payannualfee.fields.no_receipt_file')
        }
        eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
        return
      }
      requestApi({
        url: '/file/download/' + receipt_file_key + '/pdf/' + this.receipt.file_name,
        method: 'GET',
        responseType: 'blob',
        callback: (res) => {
          if (res.res_code === '401012') {
            utils.setTokenRefresh().then(() => {
              this.fnDownloadReceiptPdf()
            })
          } else {
            const downloadUrl = window.URL.createObjectURL(new Blob([res]))
            const link = document.createElement('a')
            link.href = downloadUrl
            link.setAttribute('download', 'Receipt.pdf')
            document.body.appendChild(link)
            link.click()
            link.remove()
          }
        }
      })
    }
  }
}
</script>